export enum DropdownOptionsDisplayType {
  INLINE = 'inline',
  POPPER = 'popper',
}
